import HttpClient from './httpClient';
import Logger from './services/Logger';

class NotificationController extends HttpClient {
  getNotifications = async (token) => {
    try {
      const response = await this.client.get(`/notifications`, {
        headers: {
          Authorization: token,
        },
      });
      return response.data;
    } catch (err) {
      Logger.LogError(err);
      return [];
    }
  };

  markSeenNotifications = async (token) => {
    const response = await this.client.get(`/markSeen`, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  markReadNotifications = async (token, data) => {
    const response = await this.client.post(`/markRead`, data, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  setNotificationPreferences = async (data, token) => {
    const response = await this.client.post(
      `/setNotificationPreferences`,
      data,
      {
        headers: {
          Authorization: token,
        },
      },
    );
    return response.data;
  };

  updateEmailPreferences = async (data, token) => {
    const response = await this.client.post('/emailPref', data, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  getEmailPreferences = async (token) => {
    const response = await this.client.get('/emailPref', {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };
}

export default new NotificationController(
  process.env.REACT_APP_API_BASE_URL_NOTIFICATION,
);
